export const DEFAULT_PAGE = 1;

export const SLIDER_DURATION_MS = 500;
export const CONTROLS_VISIBLE_MS = 1700;
